import React from "react"
import { Link } from "react-router-dom"
import { Container, Row, Col } from "reactstrap"
import { useTranslation } from "react-i18next"

const ServerError = () => {
  const { t } = useTranslation()
  document.title = t("Server Error | Portal")

  const handleRefresh = () => {
    window.location.reload()
  }

  return (
    <div className="account-pages">
      <Container
        style={{
          display: "flex",
          alignItems: "center",
          height: "100%",
          justifyContent: "center",
        }}
      >
        <Row style={{ justifyContent: "center" }}>
          <Col md={12} lg={12} xl={12}>
            <div className="text-center">
              <div className="mb-4">
                <h1 className="display-1 fw-bold text-secondary">500</h1>
                <h4 className="text-uppercase">{t("Internal Server Error")}</h4>
                <div className="mt-3">
                  <i className="mdi mdi-server-off display-4 text-secondary"></i>
                </div>
              </div>

              <div className="mt-4">
                <h5 className="text-muted">
                  {t("Oops! Something went wrong on our end.")}
                </h5>
                <p className="text-muted mb-4">
                  {t(
                    "We're working to fix this issue. Please try again in a few moments."
                  )}
                </p>

                <div className="d-flex justify-content-center gap-2">
                  <button className="btn btn-primary" onClick={handleRefresh}>
                    <i className="mdi mdi-refresh me-1"></i> {t("Try Again")}
                  </button>
                  <Link to="/dashboard" className="btn btn-outline-secondary">
                    <i className="mdi mdi-home me-1"></i> {t("Go to Dashboard")}
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default ServerError
